import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IVerifyEmailRequest, IVerifyEmailResponse } from '../../../entity/interface/iAuthApis';

export interface IVerifyEmailUseCase {
    execute(payload: IVerifyEmailRequest): Promise<IVerifyEmailResponse>;
}

export class VerifyEmailUseCase implements IVerifyEmailUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IVerifyEmailRequest,
    ): Promise<IVerifyEmailResponse> {
        return await this.authRepo.verifyEmail(payload);
    }
}
